/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { List, ListItem } from "@mui/material";
import { makeStyles } from "@mui/styles";
import styles from "../../styles/bottomFooterStyle.js";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { colors } from "../Theme/WebTheme.js";
import { FONT_FAMILY } from "../../common/sharedFunctions.js";
import Tooltip from "@mui/material/Tooltip";
import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

export default function BottomFooter(props) {
  const classes = useStyles();
  const settings = useSelector((state) => state.settingsdata.settings);
  const { whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont,
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont,
  });
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();

  return (
    <footer
      className={footerClasses}
      style={{ backgroundColor: "transparent" }}
    >
      <div
        className={classes.container}
        style={{
          direction: isRTL === "rtl" ? "rtl" : "ltr",
          paddingLeft: "0px",
        }}
      >
        <div
          // className={isRTL === "rtl" ? classes.right : classes.left}
          style={{ margin: "8px 0px" }}
        >
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a
                style={{
                  cursor: "pointer",
                  color: colors.Header_Background,
                  fontFamily: FONT_FAMILY,
                }}
                className={classes.block}
                href={settings.CompanyWebsite}
              >
                &copy;{" "}
                {1900 + new Date().getYear() + " " + settings.CompanyName}
              </a>
            </ListItem>

            <ListItem className={classes.inlineBlock}>
              <Button
                href="https://wa.me/905322065438?text=Hi,%20reaching%20you%20from%20bodrum.cab%20website.%20Can%20I%20get%20more%20information%20please"
                target="_blank"
                color="transparent"
                className={classes.block}
              >
                <i className={classes.footerSocialIcons + " fab fa-whatsapp"} />
              </Button>
            </ListItem>
            {settings && settings.InstagramHandle ? (
              <ListItem className={classes.inlineBlock}>
                <Tooltip
                  id="instagram-twitter"
                  title={t("follow_instagram")}
                  placement={window.innerWidth > 959 ? "top" : "left"}
                  classes={{ tooltip: classes.tooltip }}
                >
                  <Button
                    href={settings.InstagramHandle}
                    target="_blank"
                    color="transparent"
                    className={classes.block}
                  >
                    <i
                      className={
                        classes.footerSocialIcons + " fab fa-instagram"
                      }
                    />
                  </Button>
                </Tooltip>
              </ListItem>
            ) : null}
            <ListItem className={classes.inlineBlock}>
              <Button
                href="https://t.me/zaryachting"
                target="_blank"
                color="transparent"
                className={classes.block}
              >
                <i className={classes.footerSocialIcons + " fab fa-telegram"} />
              </Button>
            </ListItem>
          </List>
        </div>
      </div>
    </footer>
  );
}

BottomFooter.propTypes = {
  whiteFont: PropTypes.bool,
};
